import * as React from "react"
import * as classNames from "./BigQuoteBlock.module.scss"

const BigQuoteBlock = ({ quote, author }) => {
  
  if (!quote) {
    return <div></div>
  }

  return (
    <div className={`${classNames.BigQuoteBlock} loadin`}>
      <hr />

      <blockquote>
        <p> {quote} </p>

        {author && (
          <figcaption>
            <em> {author}</em>
          </figcaption>
        )}
      </blockquote>

      <hr />
    </div>
  )
}

export default BigQuoteBlock
